/* eslint-disable no-nested-ternary */
const PROD = {
  DEV: false,
  GA: 'UA-72837838-6',
  STRIPE_KEY: 'pk_live_tUSiWOCPqxBCdQev5uGU08F800QmOGVhSH',
  GOOGLE_CLIENT_ID: '59608194784-nfdk2r3dfh1llkbatkqtjkqm6eming1q.apps.googleusercontent.com',
  GITHUB_CLIENT_ID: 'f13d1fe968902dd01de8',
  GITHUB_REDIRECT_URL: 'https://event.hackhub.com/oauth/github',
  LINKEDIN_CLIENT_ID: '860av03wmj5s4a',
  LINKEDIN_REDIRECT_URL: 'https://event.hackhub.com/oauth/linkedin',
  MAILCHIMP_ID: '6bc6cd9fe0',
  SENTRY_DSN: 'https://a313038408e442f3a7df3ec94c773c5a@o73002.ingest.sentry.io/5397800',
  HEAP_ANALYTIC_CODE: 'window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};heap.load("119733354");'
};

const PROD_CN = {
  DEV: false,
  GA: 'UA-72837838-6',
  STRIPE_KEY: 'pk_live_tUSiWOCPqxBCdQev5uGU08F800QmOGVhSH',
  GOOGLE_CLIENT_ID: '59608194784-nfdk2r3dfh1llkbatkqtjkqm6eming1q.apps.googleusercontent.com',
  GITHUB_CLIENT_ID: '103b33be7bfe11253950',
  GITHUB_REDIRECT_URL: 'https://event.hackhub.cn/oauth/github',
  LINKEDIN_CLIENT_ID: '860av03wmj5s4a',
  LINKEDIN_REDIRECT_URL: 'https://event.hackhub.cn/oauth/linkedin',
  MAILCHIMP_ID: '6bc6cd9fe0',
  SENTRY_DSN: 'https://807413b56b4c4e1b97264c5326872b0a@o73002.ingest.sentry.io/5397780',
  HEAP_ANALYTIC_CODE: 'window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};heap.load("119733354");'
};

const DEV = {
  DEV: true,
  GA: 'UA-72837838-7',
  STRIPE_KEY: 'pk_test_cvJlKPDID2Pvp2vxrfOMaBUB',
  GOOGLE_CLIENT_ID: '664397561700-huq27prd6lgjsp3mboglops686u39qvm.apps.googleusercontent.com',
  GITHUB_CLIENT_ID: 'b3e2d7c6f6736dbe9a48',
  GITHUB_REDIRECT_URL: 'https://dev.hackhub.com/oauth/github',
  LINKEDIN_CLIENT_ID: '868wd1fwznog7v',
  LINKEDIN_REDIRECT_URL: 'https://dev.hackhub.com/oauth/linkedin',
  HEAP_ANALYTIC_CODE: 'window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};heap.load("2304655918");'
};

const LOCAL = {
  DEV: true,
  GA: 'UA-72837838-7',
  STRIPE_KEY: 'pk_test_cvJlKPDID2Pvp2vxrfOMaBUB',
  GOOGLE_CLIENT_ID: '664397561700-nrjuc8qu5cg3afs0rdlpnpb7bm0vgilh.apps.googleusercontent.com',
  GITHUB_CLIENT_ID: '97852f1c62f509fdb09f',
  GITHUB_REDIRECT_URL: 'http://localhost:3000/oauth/github',
  LINKEDIN_CLIENT_ID: '819zwkz5jkh2vm',
  LINKEDIN_REDIRECT_URL: 'http://localhost:3000/oauth/linkedin',
  HEAP_ANALYTIC_CODE: 'window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};heap.load("2304655918");'
};

exports.CONFIG =
  window.location.href.includes('localhost')
    ? LOCAL
    : process.env.REACT_APP_SERVER_ENV === 'production' && process.env.REACT_APP_SERVER_TARGET === 'cn'
      ? PROD_CN
      : process.env.REACT_APP_SERVER_ENV === 'production'
        ? PROD
        : DEV;



// WEBPACK FOOTER //
// ./src/config.js